module.exports = __webpack_public_path__ + "img/HochOben.58168f43.jpg";